// extracted by mini-css-extract-plugin
export default {"Modal":"Modal","Modal-inner":"Modal-inner","Modal-hidden":"Modal-hidden"};